<template>
  <v-dialog
    v-model="active"
    persistent
    max-width="315">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Confirmation
      </v-card-title>

      <v-card-text>
        <v-col class="px-0">
          <p>Add ฿{{ spending }} to {{ member.tel }}</p>
        </v-col>
        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="false"
        >
          <v-select
            v-model="selectBranch"
            filled
            :items="branchs"
            :rules="[ v => !!v || 'Please select branch']"
            label="Choose branch" />
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="pink"
          text
          @click="closeDialog">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="confirm">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      spending: {
        type: String,
        required: true
      },
      member: {
        type: Object,
        required: true
      },
      active: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        selectBranch: null,
        branchs: ['Siam', 'Megabangna', 'Khonkaen', 'Ngamwongwan', 'Other'],
        valid: false
      }
    },
    methods: {
      closeDialog () {
        this.$emit('onClose')
      },
      confirm () {
        this.$refs.form.validate()
        if (this.valid) {
          this.$emit('onConfirm', {
            tel: this.member.tel,
            memberId: this.member.id,
            amount: parseFloat(this.spending),
            note: 'เพิ่มยอดจากหน้าร้าน',
            reference: this.selectBranch
          })
        }
      }
    }
  }
</script>
